"use strict";

var dashboardFormCtrl = [
  "dialog",
  "Department",
  "$state",
  "myDepartments",
  "$uibModal",
  "$translate",
  "Authentication",
  "toast",
  function (
    dialog,
    Department,
    $state,
    myDepartments,
    $uibModal,
    $translate,
    Authentication,
    toast
  ) {
    var _this = this;
    this.isFocusMe = $state.current.name == "dashboard.departments.department.forms";
    this.$state = $state;
    this.baseUrl = require('../server').server;
    this.currentUserIsViewer = Authentication.isOnlyViewerInDept();
    this.currentUserIsSupervisor = Authentication.isAuthorized("supervisor");
    this.persistForm = function () {
      if (!_this.form.id) {
        return;
      }

      var id = _this.form.id;
      var departmentId = _this.form.departmentId;

      delete _this.form.id;
      delete _this.form.departmentId;
      delete _this.form.tenantId;
      delete _this.form.$promise;
      delete _this.form.$resolved;

      return Department.forms
        .updateById(
          {
            id: departmentId,
            fk: id,
          },
          _this.form
        )
        .$promise.then(function () {
          _this.form.id = id;
          _this.form.departmentId = departmentId;
          return _this.form;
        });
    };

    this.subscriptionHandler = function (formId, status) {
      if (status) {
        _this.form.subscribed = true;
      } else {
        _this.form.subscribed = false;
      }

      return _this.persistForm();
    };

    this.toggleArchive = function () {
      _this.form.archived = !_this.form.archived;
      return _this.persistForm();
    };

    this.deleteForm = function (form) {
      dialog
        .confirm({
          title: $translate.instant("DASHBOARD.DASH_FORM.DIAG_DEL.TITLE"),
          body: $translate.instant("DASHBOARD.DASH_FORM.DIAG_DEL.BODY"),
          accept: $translate.instant("DASHBOARD.DELETE"),
          cancel: $translate.instant("DASHBOARD.CANCEL"),
          size: "sm",
        })
        .then(function () {
          Department.forms
            .destroyById({
              id: $state.params.departmentId,
              fk: form.id,
            })
            .$promise.then(function () {
              _this.forms = _this.forms.filter(function (oldform) {
                return oldform.id !== form.id;
              });
            })
            .catch(function (error) {
              console.log(error);
            });
        });
    };

    this.copyForm = function (form) {
      toast.loading($translate.instant("DASHBOARD.LOADING"));
    //   console.log('llamado 2 Authentication.loadDepartments()')
      Authentication.loadDepartments().then(function () {
        $uibModal
          .open({
            animation: true,
            templateUrl: "dashboard-forms/copyFormDialog.html",
            controller: [
              "$uibModalInstance",
              "myDepartments",
              "copyDepartmentId",
              "Department",
              function (
                $uibModalInstance,
                myDepartments,
                copyDepartmentId,
                Department
              ) {
                var _this = this;
                this.copyDepartmentId = copyDepartmentId;
                this.departments = myDepartments.get();
                // console.log('llamado 6 myDepartments.get()')
                this.toFormId = undefined;
                this.joinToForm = "new";
                this.comparativeSource = [];
                this.comparativeDestination = [];
                this.listFields = function (form) {
                  let list = [];
                  let pageNumber = 0;
                  form.pages.forEach((page) => {
                    pageNumber++;
                    list.push({
                      id: page.id,
                      level: 0,
                      name: "Pagina ".concat(pageNumber),
                      type: "page",
                    });
                    page.fields.forEach(function (field) {
                      list.push({
                        id: field.id,
                        level: 1,
                        name: field.name || field.label,
                        type: field.type,
                        isArchived: field.isArchived,
                      });
                      if (field.nodes) {
                        field.nodes.forEach(function (field) {
                          list.push({
                            id: field.id,
                            level: 2,
                            name: field.name || field.label,
                            type: field.type,
                            isArchived: field.isArchived,
                          });
                        });
                      }
                    });
                  });
                  return list;
                };
                this.getForms = function (deptId) {
                  return _this.departments.find(function (el) {
                    return el.id == deptId;
                  }).forms;
                };

                this.compareForms = function () {
                  if (_this.joinToForm == "new") return;

                  let formsAvailables = _this.departments.find(function (el) {
                    return el.id == _this.copyDepartmentId;
                  }).forms;
                  let formSelected = formsAvailables.find(function (el) {
                    return el.id == _this.toFormId;
                  });
                  if (!formSelected) return;

                  Department.forms({
                    id: formSelected.departmentId,
                    filter: {
                      where: {
                        id: formSelected.id,
                      },
                    },
                  }).$promise.then(function (forms) {
                    if (!forms.length) {
                      return [];
                    }
                    formSelected = forms[0];
                    //console.log(forms[0]);
                    _this.comparativeDestination =
                    _this.listFields(formSelected);
                    //Busco campos que se agregarian
                    _this.fieldToArchive = [];
                    _this.comparativeSource.forEach(function (elS) {
                      let idxD = _this.comparativeDestination.findIndex(
                        function (elD) {
                          return elD.id == elS.id;
                        }
                      );
                      if (idxD == -1) elS.isNew = true;
                    });
                    _this.comparativeDestination.forEach(function (elS) {
                      let idxD = _this.comparativeSource.findIndex(function (
                        elD
                      ) {
                        return elD.id == elS.id;
                      });
                      if (idxD == -1) {
                        elS.notExists = true;
                        _this.fieldToArchive.push(elS.id);
                      }
                    });
                  });
                };

                this.close = function () {
                  $uibModalInstance.close({
                    departmentId: this.copyDepartmentId,
                    update: this.joinToForm,
                    formId: this.toFormId,
                    fieldToArchive: _this.fieldToArchive,
                  });
                };
                this.comparativeSource = this.listFields(form);
              },
            ],
            resolve: {
              departments: [
                "myDepartments",
                function (Member) {
                    // console.log('llamado 7 myDepartments.get()')
                  return myDepartments.get();
                },
              ],
              copyDepartmentId: function () {
                return $state.params.departmentId;
              },
            },
            controllerAs: "ctrl",
            size: "lg",
            windowClass: "dialog",
            bindToController: true,
          })
          .result.then(
            function (params) {
              $state.go("dashboard.departments.department.forms.form.builder", {
                formId: params.formId,
                oldFormId: form.id,
                oldDepartmentId: $state.params.departmentId,
                departmentId: params.departmentId,
                copy: true,
                update: params.update,
                fieldToArchive: params.fieldToArchive,
              });
            },
            function (err) {
              console.error(err);
            }
          );
      });
    };
  },
];

module.exports = function () {
  return {
    restrict: "E",
    scope: {
      form: "=",
      forms: "=",
    },
    controller: dashboardFormCtrl,
    controllerAs: "ctrl",
    bindToController: true,
    templateUrl: "dashboard-forms/dashboardFormsDirective.html",
  };
};
